import MuiPagination, { PaginationProps as MuiPaginationProps } from '@mui/material/Pagination';

export type PaginationProps = MuiPaginationProps;

export const Pagination = (props: PaginationProps) => {
  return <MuiPagination {...props} />;
};
